import { render, staticRenderFns } from "./housemaid-quote-info.vue?vue&type=template&id=5903712f&scoped=true&"
import script from "./housemaid-quote-info.vue?vue&type=script&lang=js&"
export * from "./housemaid-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-quote-info.vue?vue&type=style&index=0&id=5903712f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903712f",
  null
  
)

export default component.exports